
   document.addEventListener('DOMContentLoaded', function () {
    var isAndroid = /Android/i.test(navigator.userAgent);

    if (isAndroid) {
        var announcementBarIgnored = false;

        function adjustHeight() {

            var headerWrapper = document.querySelector('.header-wrapper');
            var announcementBarHeight = 0;

            if (!announcementBarIgnored) {
                var announcementBar = document.querySelector('.announcement-bar__link');
                announcementBarHeight = announcementBar ? announcementBar.offsetHeight : 0;
            }

            var headerWrapperHeight = headerWrapper ? headerWrapper.offsetHeight : 0;
            var innerHeight = window.innerHeight - announcementBarHeight - headerWrapperHeight;

            var menuContainer = document.querySelector('.menu-drawer__navigation-container');
            if (menuContainer) {
                menuContainer.style.height = innerHeight + 'px';
            }
        }

        window.addEventListener('scroll', function () {
            if (window.scrollY > 36) {
                announcementBarIgnored = true;
            } else {
                announcementBarIgnored = false;
            }
            adjustHeight();
        });

        adjustHeight();
        window.addEventListener('resize', adjustHeight);
    }
});
